import React, { useCallback, useEffect, useRef, useState } from "react";
import { Tooltip, Cloneable } from "../Tooltip";
import { isOverflowX } from "../utils/overFlowCheck";

export const TextToolTipCheck: React.FC<{ text: React.ReactNode; className?: string; toolTipText?: string; toolTipClassName?: string }> = ({
  toolTipText,
  className,
  text,
  toolTipClassName,
}) => {
  const [disableToolTip, setDisableToolTip] = useState(true);
  const divRef = useRef<HTMLDivElement | null>(null);
  const overFlowTest = useCallback(() => {
    if (!divRef.current) {
      return;
    }

    if (isOverflowX(divRef.current)) {
      setDisableToolTip(false);
      return;
    }
    setDisableToolTip(true);
  }, []);

  useEffect(() => {
    if (!divRef.current) {
      return;
    }
    const resizeObserver = new ResizeObserver(overFlowTest);
    resizeObserver.observe(divRef.current);

    return () => {
      resizeObserver.disconnect();
    };
  }, [overFlowTest]);

  const ElementWithToolTip: React.FC<{ children: Cloneable }> = ({ children }) => {
    return disableToolTip ? (
      <>{children}</>
    ) : (
      <Tooltip className={toolTipClassName} value={toolTipText ? toolTipText : text}>
        {children}
      </Tooltip>
    );
  };

  return (
    <div className={className} ref={divRef}>
      <ElementWithToolTip>
        <span>{text}</span>
      </ElementWithToolTip>
    </div>
  );
};
